"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33651],{

/***/ 60981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_BlogList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./themes/themes.js
var themes = __webpack_require__(89507);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/BlogList/BlogItem.js







var BlogItem = function(param) {
    var data = param.data;
    var blogItemReadBtn = (0,TranslationContext/* useTranslation */.m)().blogItemReadBtn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "blog_post flex md:flex-nowrap flex-wrap md:rounded-l-xl rounded-t-xl overflow-hidden mb-8",
        children: [
            data.resim && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: data.url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: data.title,
                    className: "shrink-0 md:w-80 w-full h-80 relative ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        loader: LoaderRemote/* default */.Z,
                        src: data.resim,
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "center",
                        alt: data.title,
                        sizes: "(max-width: 768px) 60vw, (max-width: 1200px) 25vw, 25vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 flex flex-col p-4 gap-y-3 drop-shadow-xl md:rounded-r-xl border-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: data.date
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: data.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: data.title,
                            className: "d-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "text-2xl",
                                children: data.baslik
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "opacity-60 text-base",
                        children: data.kisa_icerik
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: data.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            title: data.title,
                            className: "relative mt-auto inline-flex items-center justify-start w-48 py-3 pl-4 pr-12 overflow-hidden font-semibold text-[#000000] transition-all duration-250 ease-in-out rounded hover:pl-10 hover:pr-6 bg-brand-gray-5 group",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out ".concat(themes/* default.blogBg */.Z.blogBg, " group-hover:h-full")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "absolute right-0 pr-4 duration-250 ease-out group-hover:translate-x-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "w-5 h-5 ".concat(themes/* default.textBlog */.Z.textBlog),
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: "2",
                                            d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-250",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "w-5 h-5 text-white",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: "2",
                                            d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "relative w-full text-left transition-colors duration-250 ease-in-out group-hover:text-white",
                                    children: blogItemReadBtn
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogList_BlogItem = (BlogItem);

// EXTERNAL MODULE: ./components/BreadCrumb.js
var BreadCrumb = __webpack_require__(3605);
// EXTERNAL MODULE: ./components/BlogList/Sidebar.js + 1 modules
var Sidebar = __webpack_require__(69897);
// EXTERNAL MODULE: ./components/ProductCategory/Pagination.js + 1 modules
var Pagination = __webpack_require__(73870);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
;// CONCATENATED MODULE: ./components/Pages/BlogList.js









var BlogList = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    var blogPage = (0,TranslationContext/* useTranslation */.m)().blogPage;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(ssr.result.BlogData.result), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(ssr.result.BlogData.TotalPage), totalPage = ref1[0], setTotalPage = ref1[1];
    var ref2 = (0,react.useState)(ssr.result.BlogData.CurrentPage), currentPage = ref2[0], setCurrentPage = ref2[1];
    var setPage = function(page) {
        (0,api/* GetBlog */.pJ)(page, "").then(function(e) {
            setData(e.data.BlogData.result);
            setTotalPage(e.data.BlogData.TotalPage);
            setCurrentPage(page);
            router.replace({
                query: {
                    slug: [
                        e.data.url,
                        page
                    ]
                }
            });
        });
    };
    var SearchOnSubmit = function(SearchText) {
        var query = router.query;
        query.slug = [
            blogPage.url
        ];
        if (SearchText) {
            query.search = SearchText;
        } else {
            delete query.search;
        }
        router.replace({
            query: query
        }, undefined, {
            scroll: true,
            shallow: true
        });
        (0,api/* GetBlog */.pJ)(1, SearchText).then(function(e) {
            setData(e.data.BlogData.result);
            setTotalPage(e.data.BlogData.TotalPage);
            setCurrentPage(1);
            router.replace({
                query: {
                    slug: [
                        e.data.url
                    ],
                    search: SearchText
                }
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
                data: ssr.result.BreadCrumb,
                isAppWebView: isAppWebView
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "blog-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-12 gap-x-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:col-span-8 col-span-12",
                                children: [
                                    data.map(function(e, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList_BlogItem, {
                                            data: e
                                        }, i);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                            totalPage: totalPage,
                                            currentPage: currentPage,
                                            setPage: setPage
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                                SearchOnSubmit: SearchOnSubmit,
                                LastShared: ssr.result.BlogData.LastShared,
                                Popular: ssr.result.BlogData.Popular
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Pages_BlogList = (BlogList);


/***/ }),

/***/ 73870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductCategory_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
;// CONCATENATED MODULE: ./components/ProductCategory/PaginationItem.js


var PaginationItem = function(param) {
    var children = param.children, setPage = param.setPage, page = param.page, active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        onClick: setPage ? function() {
            setPage(page);
        } : function() {},
        className: "w-12 h-12 bg-white transition  border-2 rounded  flex items-center justify-center font-semibold text-15 cursor-pointer  hover:border-pagination-colors hover:text-pagination-colors " + (active ? "border-pagination-colors" : "border-[#D1DDE0]"),
        children: children
    });
};
/* harmony default export */ var ProductCategory_PaginationItem = (PaginationItem);

;// CONCATENATED MODULE: ./components/ProductCategory/Pagination.js




var Pagination = function(param) {
    var setPage = param.setPage, currentPage = param.currentPage, totalPage = param.totalPage;
    var Showed = 6;
    var PerSide = Showed / 2;
    var ref = (0,react.useState)([]), pages = ref[0], setPages = ref[1];
    (0,react.useEffect)(function() {
        var start = currentPage == 1 ? 1 : currentPage >= totalPage ? currentPage - PerSide + 1 : currentPage - 1;
        var arr = [];
        if (totalPage <= 3) {
            for(var i = 1; i <= totalPage; i++){
                arr.push(i);
            }
        } else {
            for(var i1 = 0; i1 <= 2; i1++){
                arr.push(start + i1);
            }
        }
        setPages(arr);
    }, [
        currentPage,
        totalPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "flex justify-center gap-x-0.5 ml:gap-x-4 mt-4",
        children: [
            currentPage != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                setPage: setPage,
                page: currentPage - 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "PaginationPrev",
                    className: "w-2"
                })
            }),
            currentPage > PerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                setPage: setPage,
                page: 1,
                children: 1
            }),
            currentPage > PerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                children: ". . ."
            }),
            pages.map(function(e, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                    setPage: setPage,
                    page: e,
                    active: e == currentPage,
                    children: e
                }, i);
            }),
            currentPage <= totalPage - PerSide + 1 && totalPage > PerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                children: ". . ."
            }),
            currentPage != totalPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                setPage: setPage,
                page: currentPage + 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "PaginationNext",
                    className: "w-2"
                })
            })
        ]
    });
};
/* harmony default export */ var ProductCategory_Pagination = (Pagination);


/***/ })

}]);